export const getTiers = (state) => state.entities.tiers;
